<template>
  <div>
    <v-skeleton-loader v-if="!group" type="card"></v-skeleton-loader>
    <v-card v-else class="pa-3 py-4">
      <!-- {{ $route.name }}{{ $route.params.id }} -->
      <v-row class="ma-0">
        <div>
          <avatar-or-initials
            :name="group.name"
            :image="group.picture"
            size="93"
            v-if="$vuetify.breakpoint.mdAndUp"
            role="button"
          />
          <!-- @click="$logEvent('group_logo_group_detail_page')" -->
          <avatar-or-initials
            v-else
            :name="group.name"
            :image="group.picture"
            role="button"
            size="64"
          />
          <!-- @click="$logEvent('group_logo_group_detail_page')" -->
        </div>
        <v-col class="ps-4">
          <v-col class="ma-0">
            <v-row class="ma-0">
              <v-col class="pa-0 text-h6 font-weight-black">
                <span role="button">
                  <div class="d-flex pt-2">
                    <div>
                      {{ group.name }}
                    </div>
                    <div class="pl-2">
                      <img
                        src="@/assets/crown.svg"
                        alt=""
                        width="30px"
                        height="30px"
                        class=""
                        v-if="group.group_type === 'Premium'"
                      />
                      <img
                        src="@/assets/private.png"
                        alt=""
                        width="20px"
                        height="16px"
                        v-else-if="group.group_type === 'Private'"
                      />
                    </div>
                  </div>
                  <div class="pt-0 mt-0 mb-2 text-body-2">
                    by
                    <b
                      style="color: #2d8cff; cursor: pointer"
                      @click="goToProfile(group.admin)"
                    >
                      {{ group.admin.profile.name }}
                    </b>
                    <span style="color: rgba(51, 51, 51, 0.7)"> (Admin)</span>
                  </div>
                </span>
              </v-col>
              <group-details-menu
                :admin-profile="group.admin.profile"
                v-if="group.is_admin || group.is_participant"
              ></group-details-menu>
              <group-details-card-actions
                class="d-none d-sm-flex"
              ></group-details-card-actions>
            </v-row>

            <!-- <v-col class="pt-0 mt-0 mb-2 text-body-2">
              by
              <b
                style="color: #2d8cff; cursor: pointer"
                @click="goToProfile(group.admin)"
              >
                {{ group.admin.profile.name }}
              </b>
              <span style="color: rgba(51, 51, 51, 0.7)"> (Admin)</span>
            </v-col> -->
          </v-col>
          <v-row class="ma-0 py-4">
            <div>
              <div class="d-flex">
                <div
                  style="min-width: 108px; cursor: pointer"
                  class="cursor-pointer py-1"
                  @click="
                    Authentecated()
                      ? toggleFollowerModal({ show: true, group: group.id })
                      : ''
                  "
                >
                  <v-icon size="22" color="black" class="icon pr-1">
                    mdi-account-group-outline
                  </v-icon>
                  <b>{{ group.participants_count }}</b>
                  <span class="stats__caption"> Members</span>
                </div>

                <div style="min-width: 108px" class="py-1">
                  <v-icon size="22" color="black" class="icon pr-1"
                    >mdi-text-box-outline</v-icon
                  >
                  <b>{{ group.trades_count }}</b>
                  <span class="stats__caption"> Trades</span>
                </div>

                <div style="min-width: 108px" class="py-1">
                  <v-icon size="22" color="black" class="icon pr-1">
                    mdi-bullseye-arrow
                  </v-icon>
                  <b class="success--text">{{ group.trade_wins }}% </b>
                  <span class="stats__caption">Wins</span>
                </div>
              </div>
              <div class="py-1">
                <div class="stats__caption">Daily P&L</div>
                <div class="d-flex">
                  <div style="min-width: 108px" class="py-1">
                    <v-icon left size="22" color="black" class="icon pr-1"
                      >mdi-sack</v-icon
                    >
                    <b
                      :class="
                        group.days_pnl >= 0 ? 'success--text' : 'red--text'
                      "
                      >{{ group.days_pnl }}</b
                    >
                    <span class="stats__caption"> P&L</span>
                  </div>

                  <div style="min-width: 108px" class="py-1">
                    <v-icon left size="22" color="black" class="icon pr-1">
                      mdi-sack-percent
                    </v-icon>
                    <b
                      :class="
                        group.days_pnl_percent >= 0
                          ? 'success--text'
                          : 'red--text'
                      "
                      >{{ group.days_pnl_percent }} %
                    </b>
                    <span class="stats__caption">P&L (% change)</span>
                  </div>
                </div>
              </div>
            </div>
          </v-row>
          <v-row class="ma-0 text-body-2" style="color: rgba(51, 51, 51, 0.87)">
            <div
              v-if="
                group.group_type === 'Premium' &&
                !group.admin.profile.is_sebi_registered
              "
            >
              <v-col>
                <span class="" style="max-width: 250px">
                  Mandatory Disclaimer: The contents of this group are not to be
                  considered as investment advice. The admin shares his/her
                  trades for educational purposes only and does not offer
                  recommendations. Please consult your financial advisor before
                  making any investments. Your capital is at risk.
                </span>
              </v-col>
            </div>
            <div class="mt-3">
              <span v-if="!readMoreActivated && group.disclaimer">
                Description: {{ group.disclaimer.slice(0, 200) }}
              </span>
              <a
                v-if="
                  !readMoreActivated &&
                  group.disclaimer &&
                  group.disclaimer.length > 200
                "
                @click="readMoreActivated = true"
                class="text-decoration-underline"
              >
                Read more
              </a>

              <span
                class="text-wrap"
                style="word-break: break-word"
                v-if="readMoreActivated && group.disclaimer"
              >
                Description: {{ group.disclaimer }}
              </span>
              <a
                v-if="readMoreActivated"
                @click="readMoreActivated = false"
                class="text-decoration-underline"
              >
                Show less
              </a>
            </div>
          </v-row>

          <group-details-card-actions
            class="d-sm-none"
          ></group-details-card-actions>
        </v-col>
      </v-row>
      <group-details-modal
        @close="detailsModal = false"
        v-model="detailsModal"
        :group="group"
      ></group-details-modal>
    </v-card>
  </div>
</template>

<script>
import AvatarOrInitials from "@/components/AvatarOrInitials.vue";
import GroupDetailsCardActions from "@/components/GroupDetailsCardActions.vue";
import GroupDetailsMenu from "./GroupDetailsMenu.vue";
import GroupDetailsModal from "./GroupDetailsModal.vue";
import { isAuthenticated } from "@/common/commonFunctions.js";

import { mapActions } from "vuex";

export default {
  components: {
    AvatarOrInitials,
    GroupDetailsCardActions,
    GroupDetailsMenu,
    GroupDetailsModal,
  },

  props: {
    group: {
      type: Object,
      detfault: null,
    },
  },

  watch: {
    group() {
      console.log(this.group);
    },
  },

  data: () => ({
    Authentecated: isAuthenticated,

    detailsModal: false,
    readMoreActivated: false,
  }),
  methods: {
    ...mapActions({
      toggleFollowerModal: "group/toggleFollowerModal",
    }),
    goToProfile(user) {
      if (this.Authentecated()) {
        if (this.group.is_admin) {
          this.$router.push({
            name: "ProfilePage",
          });
        } else {
          this.$router.push({
            name: "OthersProfilePage",
            params: {
              id: user.id,
              name: user.profile.name,
            },
          });
        }
      }
    },
    print(data) {
      console.log("THIS IS PRINTED DATA", data);
    },
  },
};
</script>

<style scoped>
.title {
  font-weight: 900;
  font-size: 1rem;
}

.stats {
  width: 100%;
}

.stats__stat {
  font-weight: 700;
}

.stats__caption {
  font-size: 0.8125rem;
  color: rgba(51, 51, 51, 0.7);
}

.actions {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
